import { render, staticRenderFns } from "./MarketingUpgradeDialog.vue?vue&type=template&id=67c319a4&scoped=true"
import script from "./MarketingUpgradeDialog.vue?vue&type=script&lang=js"
export * from "./MarketingUpgradeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c319a4",
  null
  
)

export default component.exports